import { Component, Inject, OnInit } from "@angular/core";
import { VngDialogRef, VNG_DIALOG_DATA } from "@vengreso/angular-components";
import { DialogService } from "src/app/core/core-services/services/dialog.service";
import { DataService } from "src/app/core/core-services/services/dataservices/data.service";
import { DowngradePlanThreeComponent } from "../downgrade-plan-three/downgrade-plan-three.component";

import { SubscriptionPlanType } from "../../../core/models/stripe.models";
import { formatCents, formatPrice } from "../../../utils/price-format.utils";

@Component({
    selector: "app-downgrade-option",
    templateUrl: "./downgrade-option.component.html",
    styleUrls: ["./downgrade-option.component.css"],
    standalone: false
})
export class DowngradeOptionComponent implements OnInit {
  planDowngradedFrom: string;
  starterMonthlyPrice: any = 0;
  starterYearlyPrice: any = 0;

  constructor(
    @Inject(VNG_DIALOG_DATA) public data: { planDowngradedFrom: string; planDowngradedTo: string },
    public dialog: DialogService,
    public dialogRef: VngDialogRef<DowngradeOptionComponent>,
    private dataService: DataService
  ) {
    this.getPricing();
    this.planDowngradedFrom = data.planDowngradedFrom;
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }

  chooseStarter(): void {
    this.close();
    //TODO: Send to backend
    this.dialog.openDialogComponent(
      DowngradePlanThreeComponent,
      {
        planDowngradedFrom: this.planDowngradedFrom,
        planDowngradedTo: SubscriptionPlanType.Starter,
      },
      "700px"
    );
  }

  chooseFreemium(): void {
    this.close();
    //TODO: Send to backend
    this.dialog.openDialogComponent(
      DowngradePlanThreeComponent,
      {
        planDowngradedFrom: this.planDowngradedFrom,
        planDowngradedTo: SubscriptionPlanType.Freemium,
      },
      "700px"
    );
  }

  getPricing() {
    this.dataService.get({ url: "v1/subscriptions/plans", isLoader: false }).subscribe({
      next: (response: any) => {
        // Issue #607: delegate to the shared formatter (was an inline
        // duplicate of `displayedPrice()`/`twoDecimal()`).
        const price = response.result.find(({ identifier }) => identifier == "starter-yearly").unit_amount;
        this.starterYearlyPrice = formatCents(price);
        this.starterMonthlyPrice = formatPrice(Number(this.starterYearlyPrice) / 12);
      },
      error: (error) => {},
    });
  }
}
